// extracted by mini-css-extract-plugin
module.exports = {"item":"AppListItem_item__LSfdg","dragging":"AppListItem_dragging__2m051","name":"AppListItem_name__1qkxy","groupIcon":"AppListItem_groupIcon__3zqtL"};